export const accessToDeleteBtn = (array, isManager) => {
  // pass an array of action items. must have a label key to use for filter
  const actionItems = isManager ? array : array.filter(item => item.label !== 'Delete');
  return actionItems;
};
